/* eslint max-len: 0 */
// If comments exceeded screen width have text editor auto-wrap
import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Translation } from 'react-i18next';
import CustomTemplate from '../customtemplate/customtemplate.jsx';
import getTemplate from '../../utils/gettemplate';

const UseCurrentLocation = (props) => {
  let useCurrentLocationTemplate;
  const template = getTemplate(props, 'use-current-location');
  if (template) {
    useCurrentLocationTemplate = <CustomTemplate template={template} />;
  }

  const handleCurrentLocation = () => {
    if (!navigator.geolocation.getCurrentPosition && typeof navigator.geolocation.getCurrentPosition !== 'function') {
      props.setLocationStatus('error');
    }
    // timeout
    const options = {
      enableHighAccuracy: false,
      maximumAge: 60000,
      timeout: 7000,
    };
    // This behavior should be identical to what happens during the intial load if there is no nearLocation
    return navigator.geolocation.getCurrentPosition(((position) => {
      props.setLocationStatus('ok');
      props.setUserLocation({
        userLocationString: '', 
        userLatitude: parseFloat(position.coords.latitude), 
        userLongitude: parseFloat(position.coords.longitude),
      });
    }), () => {
      props.setLocationStatus('error');
    }, options);
  };

  return (
    <div className="sb-use-current-location" onClick={handleCurrentLocation}>
      {useCurrentLocationTemplate
        || <a
          aria-label={i18n.t('closestLocations')}
          aria-controls="locations-list, Google-Map-Container"
          role="button"
          tabIndex="0"
        >
          <Translation>{(t) => t('Use my current location')}</Translation>
        </a>
      }
    </div>
  );
};

UseCurrentLocation.propTypes = {
  setLocationStatus: PropTypes.func,
  setUserLocation: PropTypes.func,
};

export default UseCurrentLocation;
